<template>
    <div class="tabbar-container">
        <div class="top shadow-bg bh bc">
            <van-button @click="go('CarGoodsQuery',{isHome:true})" class="btn btn-query">
                <div class="bh bbetween">
                    优质商品都在这
                    <div class="btn-ico-el ico-query"></div>
                </div>
            </van-button>
        </div>
        <div class="bh side-panel">
            <!--分类列表-->
            <div class="menu-panel" ref="menuScroll">
                <div>
                    <div
                        class="menu-item bh bs bstart fz_30"
                        :class="{'activate':activateIndex === index}"
                        v-for="(item,index) in classifyList"
                        :key="index"
                        @click="selectMenu(index)"
                    >{{item.name}}</div>
                </div>
            </div>

            <!--具体分类-->
            <div class="list-panel b1" ref="listScroll">
                <div>
                    <!-- 具体分类 -->
                    <div v-for="(item,index) in classifyList" :key="index" class="big-list">
                        <div class="title fz_34">{{item.name}}</div>
                        <div class="big-img">
                            <div
                                class="img bg-100 r8"
                                @click="bannerGo(item.adUrl)"
                                :style="{backgroundImage: 'url(' + item.adPic + ')'}"
                            ></div>
                        </div>
                        <div
                            v-for="(item,index) in item.children"
                            :key="index"
                            @click="showList(item)"
                            class="list-item list-item-inline"
                        >
                            <div class="item shadow-bg">
                                <div
                                    class="img bg-100"
                                    :style="{backgroundImage: 'url(' + item.iconPic + ')'}"
                                ></div>
                                <div class="content fz_24 overflow tc">{{item.name}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="big-list"></div>
                    <div class="big-list bh bc more-panel">
                        <div class="fz_24 c_999 message">更多商品敬请期待~</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mixinClassify } from "@/mixin/classify";

export default {
    mixins: [mixinClassify],
    name: "ClassifyHome",
    methods: {
        showList(item) {
            // 设置查询条件
            this.$store.state.queryParams = item;
            this.go("CarGoodsHome");
        }
    },
    // bug测试
    created() {
        this.initGroup();
    }
};
</script>
<style scoped lang="scss">
.top {
    height: 108px;
    border-bottom: 1px solid #e5e5e5;
    .btn-query {
        width: 690px;
    }
    .ico-query {
        width: 36px;
        height: 36px;
        margin-right: 0;
    }
}
.side-panel {
    height: calc(100% - 109px);
}
</style>